import { message } from 'antd';

// Normalize base URL and ensure it targets v1 API
const RAW_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5002/';
const NORMALIZED_BASE = RAW_BASE_URL.endsWith('/') ? RAW_BASE_URL : `${RAW_BASE_URL}/`;
const API_BASE_V1 = NORMALIZED_BASE.includes('/v1/') ? NORMALIZED_BASE : `${NORMALIZED_BASE}v1/`;

class ClickUpConfigApi {
  // Get auth token from localStorage
  getAuthToken() {
    return localStorage.getItem('authToken');
  }

  // Get ClickUp configuration
  async getConfig() {
    try {
      const response = await fetch(`${API_BASE_V1}settings/clickup`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${this.getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        if (response.status === 404) {
          // No config exists yet
          return null;
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      // Return the data property from the response
      return result.data;
    } catch (error) {
      console.error('Error fetching ClickUp config:', error);
      message.error('Failed to fetch ClickUp configuration');
      throw error;
    }
  }

  // Create ClickUp configuration
  async createConfig(configData) {
    try {
      const response = await fetch(`${API_BASE_V1}settings/clickup`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${this.getAuthToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(configData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      message.success('ClickUp configuration created successfully');
      return result.data;
    } catch (error) {
      console.error('Error creating ClickUp config:', error);
      message.error(`Failed to create ClickUp configuration: ${error.message}`);
      throw error;
    }
  }

  // Update ClickUp configuration
  async updateConfig(configData) {
    try {
      const response = await fetch(`${API_BASE_V1}settings/clickup`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${this.getAuthToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(configData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      message.success('ClickUp configuration updated successfully');
      return result.data;
    } catch (error) {
      console.error('Error updating ClickUp config:', error);
      message.error(`Failed to update ClickUp configuration: ${error.message}`);
      throw error;
    }
  }

  // Test ClickUp connection
  async testConnection(configData) {
    try {
      const response = await fetch(`${API_BASE_V1}settings/clickup/test`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${this.getAuthToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(configData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.success) {
        message.success(`Connection test successful! Found ${result.data?.teamsCount || 0} teams.`);
      } else {
        message.error(`Connection test failed: ${result.message}`);
      }
      
      return result;
    } catch (error) {
      console.error('Error testing ClickUp connection:', error);
      message.error(`Connection test failed: ${error.message}`);
      throw error;
    }
  }
}

export default new ClickUpConfigApi();